<div class:pickedCard={profile.pickedCard} class="badge" in:AnimIN out:AnimOUT>
    <div class="image" style="background-image:url('{profile.img}');"></div>
    <div class="name">{profile.name}</div>
    <div class="points numerals">{profile.points}</div>
</div>

<style>
.badge{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px;
}
.image{
    width: 70px;
    height: 70px;
    background-size: contain;
    background-position: 50% 50%;
    border-radius: 50%;
    background-color: #fff;
    transform: box-shadow 300ms ease-in-out;
    box-shadow:  10px 10px 29px #d3801a, 
             -10px -10px 29px #ffad23;
    transition: all 300ms ease-in-out;
}
.name{
    font-size: 1em;
    font-weight: 400;
    transition: all 300ms ease-in-out;
}
.points{
    font-size: 0.7em;
    font-weight: 400;
    transition: all 300ms ease-in-out;
}
.pickedCard > .name{
    color: #fff;
    font-size: 1.1em;
}
.pickedCard > .image{
    width: 80px;
    height: 80px;
    box-shadow:  10px 10px 29px var(--kilo), 
             -10px -10px 29px var(--mega);
}
</style>

<script>
import { AnimIN, AnimOUT } from "../../code/anim.js"

export let profile
</script>